export default {
  AUTHORIZATION(state, payload) {
    state.authorization = payload;
  },
  SET_USER(state, payload) {
    state.users = localStorage.setItem('userinfo', JSON.stringify(payload));
  },
  SET_USER_ROLES(state, payload) {
    state.userRoles = payload
  },
  SET_REFERRALS(state, payload) {
    state.referrals.userReferralInfos = [];
    state.referrals = payload;
  },
  SET_NOTIFICATIONS(state, payload) {
    state.notifications = payload
  },
  UPDATE_PROFILE(state, payload) {
    state.users = payload;
  },
  SET_TRAC(state, payload) {
    state.trac = payload;
  },
  SET_GOAL(state, payload) {
    state.goal = payload;
  },
  SET_MILESTONE(state, payload) {
    state.milestone = payload;
  },
  SET_TASKS(state, payload) {
    state.tasks = payload;
  },
  SET_POST_COMMIT(state, payload) {
    state.post = payload;
  },
  SET_ASPIRATION(state, payload) {
    state.aspiration = payload;
  },
  SET_AVATAR_IMG(state, payload) {
    state.avatarImg = payload
  },
  SET_LOGO(state, payload) {
    state.logo = payload
  },
  SET_METRICS_LOADING(state, payload) {
    state.metrics.loading = payload
  },
  SET_METRICS(state, payload) {
    state.metrics.data = payload
  },
  SET_METRICS_ERROR(state, payload) {
    state.metrics.isError = payload
  },
  SET_CATEGORIES(state, payload) {
    state.categories = payload;
  },
  SET_CALENDAR(state, payload) {
    state.calendar = payload;
  }
}
